const PHONE_CALL_OUTCOMES = [
    { value: "no_answer", label: "No Answer" },
    { value: "voicemail", label: "Voicemail" },
    { value: "gatekeeper", label: "Gatekeeper" },
    { value: "wrong_number", label: "Wrong Number" },
    { value: "wrong_person", label: "Wrong Person" },
    { value: "not_interested", label: "Not Interested" },
    { value: "follow_up", label: "Follow Up" },
    { value: "qualified", label: "Qualified" },
    { value: "meeting_booked", label: "Meeting Booked" },
    { value: "do_not_contact", label: "Do Not Contact" },
];

const OUTCOME_VALUES = new Set(PHONE_CALL_OUTCOMES.map((option) => option.value));

function normalizePhoneCallOutcome(value) {
    const normalized = String(value || "").trim().toLowerCase().replace(/[ -]+/g, "_");
    return OUTCOME_VALUES.has(normalized) ? normalized : "";
}

function getPhoneCallOutcomeLabel(value) {
    const normalized = normalizePhoneCallOutcome(value);
    const option = PHONE_CALL_OUTCOMES.find((candidate) => candidate.value === normalized);
    if (option) {
        return option.label;
    }
    const legacy = String(value || "").trim().replace(/[_-]+/g, " ");
    return legacy ? legacy.replace(/\b\w/g, (letter) => letter.toUpperCase()) : "-";
}

export { PHONE_CALL_OUTCOMES, getPhoneCallOutcomeLabel, normalizePhoneCallOutcome };